import React, { useState } from "react";
import StateTransitionsComponent from "./StateTransitionsComponent";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { STATE_TRANSITION_QUERY } from "./queries";
import PropTypes from "prop-types";

const StateTransitionsContainer = ({ documentId }) => {
  const [stateTransitionReason, setStateTransitionReason] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const { loading, data: stateTransitions } = useQueryWithSimpleErrorHandling(STATE_TRANSITION_QUERY, {
    variables: { documentId },
    fetchPolicy: "network-only",
    skip: !documentId
  });

  const handleViewReasons = transitionReasons => event => {
    setAnchorEl(event.currentTarget);
    setOpen(prev => !prev);
    let transitionReason = "";
    for (let i = 0; i < transitionReasons.length; i++) {
      if (i === transitionReasons.length - 1) {
        transitionReason = transitionReason + transitionReasons[i];
      } else {
        transitionReason = transitionReason + transitionReasons[i] + ", ";
      }
    }
    setStateTransitionReason(transitionReason);
  };

  return (
    !loading && (
      <StateTransitionsComponent
        stateTransitions={stateTransitions}
        stateTransitionReason={stateTransitionReason}
        onViewReasons={handleViewReasons}
        open={open}
        anchorEl={anchorEl}
      />
    )
  );
};

StateTransitionsContainer.propTypes = {
  documentId: PropTypes.number
};

export default StateTransitionsContainer;
